import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson11: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson10"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[120%]">Researching Crypto</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson12"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[9.63rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-gainsboro-100 font-dm-sans">

        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            DYOR, otherwise known as Do Your Own Research is used throughout the
            crypto community and for good reason. Before putting your
            hard-earned money into crypto investments it's wise to spend some
            time researching and investigating the cryptocurrency's legitimacy.
            As you begin your cryptocurrency journey you will see this term
            frequently used.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The #1 reason you should do your own research is that ultimately, it
            is your money to win but also your money to lose. Losing is
            obviously something you want to minimize at all costs and doing so
            starts with educating yourself about your potential investment.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            If you are looking to invest in Bitcoin or any other cryptocurrency,
            digital asset, or blockchain platform, you should always start by
            doing your own research.
          </p>
        </div>
        <img
          className="relative w-[53.75rem] h-[29.94rem] object-cover"
          alt=""
          src="/i47@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>Research Considerations</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>1.) Identify potential investments</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>2.) Set a list of investment goals</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>3.) Figure out how much you can afford to lose</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>4.) Technical/Fundamental Analysis</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>5.) Make an informed decision</span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[5.63rem] text-[1.88rem] text-white">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Identifying Potential Investments</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Create a list of potential investments with cryptocurrency
                  coins and tokens that appeal to you.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Find a healthy amount of transparent information about the
                  project. The more information you can find about a given
                  digital asset, especially from independent sources, the
                  better.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[36rem] h-[20.01rem] object-cover"
            alt=""
            src="/i48@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            In doing so make sure you consider the following:
          </p>
          <ul className="m-0 font-inherit text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              Identify the cryptocurrency's purpose
            </li>
            <li className="mb-[false]">
              Does it solve a real-world problem or serve another function
              outside of supporting the currency itself?
            </li>
            <li className="mb-[false]">Identify the project's whitepaper</li>
            <li className="mb-[false]">
              Is it clearly and professionally written?
            </li>
            <li className="mb-[false]">
              What are their mission and goals details
            </li>
            <li className="mb-[false]">
              Identify where you can buy/sell the cryptocurrency
            </li>
            <li className="mb-[false]">
              Does it have ties/major links to the larger exchanges?
            </li>
            <li className="mb-[false]">
              Anything other than an exchange would be wise to initially avoid
            </li>
            <li className="mb-[false]">Identify the creators of the coin</li>
            <li className="mb-[false]">Decentralization is everything</li>
            <li className="mb-[false]">
              It creates efficient/reliable administration
            </li>
            <li className="mb-[false]">
              Ensures rights of local population (better protects those in the
              minority)
            </li>
            <li className="mb-[false]">Improves local development</li>
            <li className="mb-[false]">
              Legitimate crypto projects have a publicly listed Board of
              Directors
            </li>
            <li className="mb-[false]">
              They can also have partnered organizations supporting them
            </li>
            <li className="mb-[false]">
              You should be able to research these names/orgs to ensure
              legitimacy
            </li>
            <li className="mb-[false]">
              Determine if the coin seems sustainable
            </li>
            <li className="mb-[false]">
              Utilize all information from above to determine
            </li>
            <li className="mb-[false]">
              Any red flags from above taken into account
            </li>
            <li className="mb-[false]">
              Coin should solve a problem and solving that problem should be
              creator's main goal
            </li>
          </ul>
          <p className="m-0">
            The more information you find from different independent sources
            about that cryptocurrency is a good sign. However, if the only
            information you find is from the project's website or clearly biased
            article sources then be very cautious! Better to be safe than sorry.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-white">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>List of Investment Goals</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Create a list of investment goals considering some of the
                following questions:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Are you looking for short, medium, or long-term timeframe for
                  your investments?
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  What is your risk appetite? How much are you willing to put
                  into a play
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Short term investments include day trading and scalping. Do
                  you have the aptitude for it?
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Medium-Long Term investments normally have less risk involved
                  and suitable for those with conservative investment goals
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                From the prospective list created when identifying potential
                investments use the above questions to help narrow that list
                into a shorter one by eliminating risky crypto projects that
                don't align with your goals/values.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.31rem] text-white">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem]">
              <b>
                <span>Afford To Lose</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Decide for yourself how much are you willing to lose in any
                  given investment.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Consider these following questions when deciding this amount:
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Will this amount lost make or break your quality of life?
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Is this rent, grocery or tuition money? Can I still pay
                    these necessities if I lose this?
                  </span>
                </span>
              </li>
              <li>
                <span>
                  <span>Am I fine with potentially losing it all?.</span>
                </span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[37.31rem] h-[32.98rem] object-cover"
            alt=""
            src="/i49@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          These should help you trim down options to a well-thought-out and
          intelligent amount that can be lost and won't hurt you as much as it
          might others. Always approach your crypto investments with the mindset
          that it is possible you can lose it all.
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-[1.88rem] text-white">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Technical/Fundamental Analysis</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Technical Analysis is the study of historical price action to
                  predict future price action. It's a form of research that is
                  most beneficial for short-term plays but can also provide
                  backing for medium-long term plays as well.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Generally, when you think of doing research, it usually means
                  looking into the cryptocurrency project team, roadmap,
                  funding, and accomplishments to date (fundamental analysis).
                  However, Technical Analysis focuses more on analysis of the
                  live price charts to identify trends and determine market
                  direction. Charting tools are use to interpret market pricing
                  data.
                </span>
              </span>
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            Learning the basic technical analysis skills will benefit you long
            term in crypto investing. But it is an advanced technique so if you
            need any assistance feel free to ask our support team within the
            server!
          </p>
          <p className="m-0">
            Fundamental Analysis focuses on every aspect of an asset that
            contributes to its overall value. So like mentioned above it looks
            into the roadmap, funding, target market, development, competition,
            etc.
          </p>
          <p className="m-0">Think of it with these simple steps:</p>
          <p className="m-0">
            1.) Identify a ticker/topic (Question you need answered)
          </p>
          <p className="m-0">2.) Gather all the sources and information</p>
          <p className="m-0">
            3.) Thoroughly investigate and cross-check references
          </p>
          <p className="m-0">4.) Create a conclusion guided by a prompt</p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.31rem] text-[1.88rem] text-white">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Informed Decisions</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Final thing to consider while researching a cryptocurrency to
                  invest in is the time to make decisions.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  After gathering all this data utilizing various methods listed
                  above you now have a concise list of potential investments
                  based on your risk appetite. They have been looked over
                  thoroughly and tick off all of the boxes you have set for it.
                  You are now able to lay all of the data out and make an
                  informed decision on this crypto investment.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[38.69rem] h-[29.23rem] object-cover"
            alt=""
            src="/i50@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          More than likely if everything was done correctly this will be a solid
          investment. Of course, remember it's not guaranteed because the crypto
          market is inherently volatile. Even the best projects sometimes
          struggle you just have to ensure you set the right measures in place
          to protect yourself for every scenario.
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">Takeaways</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If you have already started researching, great job you are
                already ahead of most. Need some resources to lean on for
                additional help? Here are a few resources for researching
                cryptocurrency investments that will guide you on the right path
                to conducting proper research.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <a
                className="text-[inherit]"
                href="https://academy.binance.com/"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      Binance Academy
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span>
                  {" "}
                  — An awesome tool for learning about everything blockchain
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <a
                className="text-[inherit]"
                href="https://www.coursera.org/courses?query=cryptocurrency"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      Coursera
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span>
                  {" "}
                  — Blockchain and cryptocurrency courses for beginners
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <a
                className="text-[inherit]"
                href="https://www.coindesk.com/"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      CoinDesk
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span>
                  {" "}
                  — The latest cryptocurrency news and live Bitcoin prices
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <a
                className="text-[inherit]"
                href="https://icodrops.com/"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      ICO Drops
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span> — Historical price data for cryptocurrency ICOs</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <a
                className="text-[inherit]"
                href="https://www.theblockcrypto.com/"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      The Block
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span>
                  {" "}
                  — An in-depth cryptocurrency journal with tons of in-depth
                  analysis
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <a
                className="text-[inherit]"
                href="https://www.tradingview.com/"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      TradingView
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span>
                  {" "}
                  — A social network for following crypto market price and chart
                  views
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                These informative tools along with our guides and Discord server
                support should help you learn as quickly and efficiently as
                possible! Remember you can always ask us for clarification on
                anything you might need.
              </span>
            </span>
          </p>
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300"
        href="/lesson12">
        <div className="w-full">
          <b className="inline-block flex-1 w-full relative text-center pb-[0.8rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson11;
